<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Members By Status</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                    <input class="form-control" type="text" name="search" id="search" placeholder="Search"
                                        v-model="serverParams.customFilters.name" @keyup="loadItems()">
                                </div>
                                <div class="col-md-3">
                                </div>
                            </div>
                        </div>
                       <CircleLoader v-if="isLoading" />
                        <vue-good-table
                        mode="remote"
                        :totalRows="totalRecords"
                        :isLoading="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPage: serverParams.perPage,
                            perPageDropdown: [10, 20, 50, 100, 200],
                        }"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: {
                                field: 'Practice',
                                type: 'desc',
                            },
                        }"
                        :rows="rows"
                        :columns="columns"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'name'">
                                    <span>{{ props.row.user.Name }}</span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 
Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    name: ''
                },
                sort: [
                    {
                        field: 'Practice', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Members Name',
                    field: 'Name',
                    filterable: true,
                },
                {
                    label: 'Position',
                    field: 'Status',
                    sortable: true,
                },
                {
                    label: 'Practice',
                    field: "Practice",
                    sortable: true,
                },
                {
                    label: 'Status',
                    field: "MemberStatus",
                    sortable: true,
                },


            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: []
        };
    },
    methods: {
        loadItems() {
  this.isLoading = true;
  API.getAllStatus(this.serverParams,
    data => {
      this.totalRecords = data.totalRecords; // Use the totalRecords from the root of the response
      this.rows = data.data.data;
      this.rows.forEach(q => {
        const data = { 
          full_name: `${q.user.FirstName} ${q.user.FirstName}`,
          spot_status: (q.user.MemberStatus === 'active') ? true : false,
        }
        this.spots.push(data);
      });
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    })
},

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>